import React, { useEffect, useState } from "react";
import Graph from "../../../../components/Graph/Graph";
import Bargraph from "../../../../components/Graph/Bargraph";
import Box1 from "../../../TeamLeader/Dashboard/box/Box";
import Box from "../../../../components/box/Box";
import ReferallTimeline from "./ReferallTimeline/ReferallTimeline";
import userImg from "./users.png";
import Paragraph from "antd/es/typography/Paragraph";
import { getListOfTeams } from "../../../../service/getListOfTeams";

import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  getDocs,
  where,
} from "firebase/firestore";
import { db } from "../../../../firebase-config";
import { notification } from "antd";
import { getMyARIDFromUid } from "../../../../service/getMyARIDFromUid";
import styles from "./Sales.module.css";
import { useAuth } from "../../../../provider/Auth.provider";

const Sales = () => {
  const [arID, setArID] = useState("");
  const { user } = useAuth();

  useEffect(() => {
    const fetchARID = async () => {
      const uid = user.uid;
      if (uid) {
        const arID = await getMyARIDFromUid(uid);
        setArID(arID);
      }
    };

    fetchARID();
  }, []);

  const [isAutoAssignModal, setIsAutoAssignModal] = useState(false);
  const [teams, setTeams] = useState([]);
  const [targetId, setTargetId] = useState(null);
  const [clubTargetValue, setClubTargetValue] = useState(0);
  const [data, setData] = useState(null);
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalUsersGrowth: 0,
    totalTeamLeaders: 0,
    teamLeaderGrowth: 0,
    totalTeamMembers: 0,
    teamMemberGrowth: 0,
  });
  const [changes, setChanges] = useState({ targetChange: 0 });
  useEffect(() => {
    const fetchTeams = async () => {
      const teamsData = await getListOfTeams();
      console.log(teamsData, "getting all team");
      setTeams(teamsData);
    };
    fetchTeams();
  }, []);

  function getCurrentMonth() {
    return new Date().getMonth() + 1;
  }

  function getCurrentYear() {
    return new Date().getFullYear();
  }

  const fetchSalesData = async () => {
    try {
      const q = query(
        collection(db, "targets"),
        where("targetMonth", "==", getCurrentMonth()),
        where("targetYear", "==", getCurrentYear())
      );
      const q1 = query(
        collection(db, "targets"),
        where("targetMonth", "==", getCurrentMonth() - 1),
        where("targetYear", "==", getCurrentYear())
      );

      const querySnapshot = await getDocs(q);
      const querySnapshot1 = await getDocs(q1);
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const data1 = querySnapshot1.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      if (data.length > 0) {
        setData(data[0]);
        const target = data[0];
        setClubTargetValue(target.targetNumber);
        setTargetId(target.id);
      }
      const change =
        data.length > 0 && data1.length > 0
          ? data[0].targetNumber - data1[0].targetNumber
          : 0;
      setChanges({ targetChange: change });
    } catch (error) {
      console.error("Error fetching target data:", error);
    }
  };

  useEffect(() => {
    fetchSalesData();
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const snapshot = await getDocs(collection(db, "users"));
        if (snapshot.empty) return;

        const users = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // start of today
        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);

        // yesterday
        const startOfYesterday = new Date(startOfToday);
        startOfYesterday.setDate(startOfYesterday.getDate() - 1);

        // --- Helpers ---
        const parseDate = (createdAt) => {
          if (!createdAt) return null;
          const [day, month, year] = createdAt.split(" ")[0].split("-");
          return new Date(`20${year}-${month}-${day}`);
        };

        // --- Total Users ---
        const totalUsers = users.length;

        const totalUsersYesterday = users.filter((u) => {
          const createdDate = parseDate(u.createdAt);
          return createdDate && createdDate < startOfToday;
        }).length;

        const totalUsersGrowth = totalUsersYesterday
          ? ((totalUsers - totalUsersYesterday) / totalUsersYesterday) * 100
          : 0;

        // --- Team Leader / Team Member Counts ---
        const teamLeaders = users.filter((u) => u.userTypes === "team_leader");
        const teamMembers = users.filter((u) => u.userTypes === "team_member");

        const totalTeamLeaders = teamLeaders.length;
        const totalTeamMembers = teamMembers.length;

        // Yesterday counts
        const teamLeadersYesterday = teamLeaders.filter((u) => {
          const createdDate = parseDate(u.createdAt);
          return createdDate && createdDate < startOfToday;
        }).length;

        const teamMembersYesterday = teamMembers.filter((u) => {
          const createdDate = parseDate(u.createdAt);
          return createdDate && createdDate < startOfToday;
        }).length;

        // Growth %
        const teamLeaderGrowth = teamLeadersYesterday
          ? ((totalTeamLeaders - teamLeadersYesterday) / teamLeadersYesterday) *
            100
          : 0;

        const teamMemberGrowth = teamMembersYesterday
          ? ((totalTeamMembers - teamMembersYesterday) / teamMembersYesterday) *
            100
          : 0;

        // --- Final Stats ---
        setStats({
          totalUsers,
          totalUsersGrowth: totalUsersGrowth.toFixed(1),
          totalTeamLeaders,
          teamLeaderGrowth: teamLeaderGrowth.toFixed(1),
          totalTeamMembers,
          teamMemberGrowth: teamMemberGrowth.toFixed(1),
        });
      } catch (e) {
        console.error("Error fetching user stats:", e);
      }
    };

    fetchStats();
  }, []);

  const [counts, setCounts] = useState({ direct: 0, indirect: 0, total: 0 });

  // Fetch referral counts on mount / when user changes
  const getReferrals = async () => {
    if (!user?.uid) return;

    try {
      // Correctly get the referrals subcollection
      const referralsRef = collection(db, "users", user.uid, "referrals");
      const snapshot = await getDocs(referralsRef);

      let direct = 0;
      let indirect = 0;

      snapshot.forEach((doc) => {
        const data = doc.data();
        if (data.referType === "active") direct++;
        else if (data.referType === "passive") indirect++;
      });

      setCounts({ direct, indirect, total: direct + indirect });
    } catch (error) {
      console.error("Error fetching referrals:", error);
    }
  };

  useEffect(() => {
    getReferrals();
  }, [user?.uid]);

  return (
    <div className={styles.sales}>
      <h1 className={styles.heading}>Education & Progress</h1>
      <h2 className={styles.heading}>
        Your Referral ID is :{" "}
        <Paragraph className={styles.copyable} copyable>
          {arID}
        </Paragraph>
      </h2>

      <div className={styles.boxes}>
        <Box1
          subhed={"Sales Target"}
          value={clubTargetValue}
          growth={changes.targetChange}
          logo={userImg}
        />
        <Box
          subhed={"Team Member"}
          value={stats.totalTeamMembers}
          growth={stats.teamMemberGrowth}
          logo={userImg}
        />
        <Box subhed={"Direct User"} value={counts.direct} logo={userImg} />
        <Box subhed={"Indirect User"} value={counts.indirect} logo={userImg} />
      </div>

      <div className={styles.graphes}>
        <Graph />
        <Bargraph />
      </div>
      <div className={styles.courses}>Club Structure</div>
      <div className={styles.pro}>
        <ReferallTimeline />
      </div>
    </div>
  );
};

export default Sales;
